"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_SELECTED = exports.PROFILE_UPDATE_SUCCESS = void 0;
exports.PROFILE_UPDATE_SUCCESS = 'Profile:Update:Success';
exports.ACCOUNT_SELECTED = 'Account:Select';
